import type * as z from "zod";

/**
 * Gemeinsame Regeln abhängig von `PUBLIC_DEPLOYMENT_ENVIRONMENT`.
 * Wird über `createFinalSchema` von `@t3-oss/env-core` angebunden (siehe env.t3.gg → Customization).
 */
export function deploymentEnvSuperRefine(
  data: Record<string, unknown>,
  ctx: z.core.$RefinementCtx,
  options: { includeServerMailRules: boolean }
): void {
  const deploy = data.PUBLIC_DEPLOYMENT_ENVIRONMENT;
  if (typeof deploy !== "string") {
    return;
  }

  if (options.includeServerMailRules && deploy !== "localhost") {
    if (data.RESEND_API_KEY === undefined) {
      ctx.addIssue({
        code: "custom",
        message: "RESEND_API_KEY ist außerhalb von localhost erforderlich.",
        path: ["RESEND_API_KEY"],
        continue: false,
      });
    }
    if (data.WEBAPP_THROTTLE_REQUESTS_IN_MS !== undefined) {
      ctx.addIssue({
        code: "custom",
        message: "WEBAPP_THROTTLE_REQUESTS_IN_MS darf nur in localhost gesetzt sein.",
        path: ["WEBAPP_THROTTLE_REQUESTS_IN_MS"],
        continue: false,
      });
    }

    const hasStaticKey = typeof data.CLASH_OF_CLANS_API_KEY === "string" && data.CLASH_OF_CLANS_API_KEY.length > 0;
    const hasInfisical =
      typeof data.INFISICAL_CLIENT_ID === "string" &&
      typeof data.INFISICAL_CLIENT_SECRET === "string" &&
      typeof data.INFISICAL_PROJECT_ID === "string" &&
      typeof data.INFISICAL_ENVIRONMENT === "string";
    if (!hasStaticKey && !hasInfisical) {
      ctx.addIssue({
        code: "custom",
        message:
          "Außerhalb von localhost muss entweder CLASH_OF_CLANS_API_KEY oder INFISICAL_CLIENT_ID + INFISICAL_CLIENT_SECRET + INFISICAL_PROJECT_ID + INFISICAL_ENVIRONMENT gesetzt sein.",
        path: ["CLASH_OF_CLANS_API_KEY"],
        continue: false,
      });
    }
  }
}
